<div class="content-container">
  <mat-checkbox [ngModelOptions]="{standalone: true}" [ngModel]="personsPerSquareMeterComponent?.overrideDefaultValue"
    (ngModelChange)="personsPerSquareMeterComponent.overrideDefaultValue = $event" class="margin-right form-field"
    *ngIf="showFeaturePersonsPerSquareMeter">
    Override default value
  </mat-checkbox>
  <mat-form-field appearance="outline" class="form-field"
    *ngIf="showFeaturePersonsPerSquareMeter && personsPerSquareMeterComponent.overrideDefaultValue">
    <mat-label>Amount of people</mat-label>
    <input matInput type="number" step="0.5" [ngModel]="personsPerSquareMeterComponent?.amountOfPeople"
      (ngModelChange)="personsPerSquareMeterComponent.amountOfPeople = $event" autocomplete="off">
  </mat-form-field>
  <mat-form-field class="form-field">
    <mat-label>Number of steps</mat-label>
    <mat-select class="text-right" [value]="stair?.numberOfSteps" (selectionChange)="changeSteps($event.value)">
      <mat-option class="select-without-checkbox" *ngFor="let step of stepAmounts" [value]="step.ID">
        {{step.Name}}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>